import { Component, EventEmitter, Input, OnDestroy, Output, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import {
  SubscriptionDetail,
  SubscriptionFrequency,
  SubscriptionPayload,
} from '../../../_interfaces/subscription.interface';
import { Store } from '@ngxs/store';
import { SubscriptionApiService } from '../../../_services/subscription-service/api/subscription-api-service.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-subscription-packages',
  imports: [RouterLink, NgClass],
  templateUrl: './subscription-packages.component.html',
})
export class SubscriptionPackagesComponent implements OnDestroy {
  readonly store = inject(Store);
  readonly subscriptionApiService = inject(SubscriptionApiService);
  readonly router = inject(Router);

  @Output() packageChange = new EventEmitter<SubscriptionPayload>();
  @Output() frequencyChange = new EventEmitter<Partial<SubscriptionPayload>>();
  @Input() currentPackage: SubscriptionPayload | undefined;
  packages?: SubscriptionDetail[];
  isMonthly: boolean = true;
  readonly subscriptions = new Subscription();

  constructor() {
    this.getSubscriptionPackages();
  }

  getSubscriptionPackages() {
    this.subscriptions.add(
      this.subscriptionApiService.getSubscriptionPackages().subscribe({
        next: (res) => {
          this.packages = res;
          if (this.currentPackage) {
            this.isMonthly = this.currentPackage?.frequency === SubscriptionFrequency.MONTHLY;
          }
        },
      }),
    );
  }

  toggleMonthly() {
    return;
    // TEMP ignore until html is enabled again
    //   this.isMonthly = !this.isMonthly;
    //   const data: Partial<SubscriptionPayload> = {
    //     frequency: this.isMonthly ? SubscriptionFrequency.MONTHLY : SubscriptionFrequency.YEARLY,
    //   };
    //   this.frequencyChange.emit(data);
  }

  onSelectPackage(id: number) {
    if (this.currentPackage) this.currentPackage.package = id;
    const data: SubscriptionPayload = {
      package: id,
      frequency: this.isMonthly ? SubscriptionFrequency.MONTHLY : SubscriptionFrequency.YEARLY,
    };
    this.packageChange.emit(data);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  protected readonly SubscriptionFrequency = SubscriptionFrequency;
}
